import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: "production",
  apiVersion: "2022-02-01",
  useCdn: false,
  token: process.env.REACT_APP_SANITY_TOKEN,
  ignoreBrowserTokenWarning: true,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

export const getUrlFromId = (ref) => {
  const [_file, id, extension] = ref.split("-");
  return `https://cdn.sanity.io/${_file}s/${process.env.REACT_APP_SANITY_PROJECT_ID}/production/${id}.${extension}`;
};
